import type { ScreenModule } from "../../../app/screen-module";
import { SessionListPage } from "../ChatPage";

export default {
	id: "end-user.sessions",
	path: "/app/sessions",
	area: "end-user",
	navGroup: "はたらく",
	label: "会話履歴",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: SessionListPage,
} satisfies ScreenModule;
